module.exports = __webpack_public_path__ + "static/media/no-transactions.569eb053.svg";